import { gql } from '@apollo/client';

export const GET_EDUCATIONS = gql`
  query Educations {
    educations {
      id
      name
    }
  }
`;

export const GET_EXPERIENCES = gql`
  query Experiences {
    experiences {
      id
      name
    }
  }
`;

export const GET_REGIONS = gql`
  query Regions {
    regions {
      default
      id
      name
    }
  }
`;

export const GET_STATISTIC = gql`
  query Statistic($adType: AdTypeEnum!) {
    statistic(adType: $adType) {
      month
      week
    }
  }
`;

export const GET_SUGGESTIONS = gql`
  query SearchSuggestions($searchTerm: String!, $targetType: AdTypeEnum!) {
    searchSuggestions(searchTerm: $searchTerm, targetType: $targetType) {
      id
      searchTerm
    }
  }
`;
